import { useEffect, useState } from "react";
import { formatDateTime } from "../formatDateTime/formatDateTime";
import { formatIanaTimezoneToDropdownOption } from "../formatIanaTimezoneToDropdownOption/formatIanaTimezoneToDropdownOption";
import { getIanaTimezones } from "../getIanaTimezones/getIanaTimezones";
import { getMinutes } from "date-fns";
import { TFunction } from "i18next";
import { Timezone } from "../../TimezoneList/TimezoneList";
export const useTimezones = (t: TFunction) => {
  const [currentMinute, setCurrentMinute] = useState(getMinutes(new Date()));
  const initialTimezones = getIanaTimezones().map(timezone => formatIanaTimezoneToDropdownOption(timezone, t));
  const [timezones, setTimezones] = useState<Timezone[]>(initialTimezones);
  useEffect(() => {
    const interval = setInterval(() => {
      const minute = getMinutes(new Date());
      if (minute !== currentMinute) {
        setTimezones(timezones.map(item => {
          return {
            ...item,
            dateAndTime: formatDateTime(new Date(), item.id)
          };
        }));
        setCurrentMinute(minute);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [currentMinute, timezones]);
  return timezones;
};